/*
 * Clase Account WorkingShiftGroup, clase utilizada
 * para las vista Account manager.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import moment from 'moment';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as accountWorkingShiftGroupActions from '../../actions/account_working_shift_group/index';

/* Style */
import '../../../../public/style/dashboard.scss';

/* Components */
import Header from '../../components/account_working_shift_group/header';
import Title from '../../components/account_working_shift_group/title';
import Buttons from '../../components/account_working_shift_group/buttons';
import Table from '../../components/account_working_shift_group/table';
import ModalEdit from '../../components/account_working_shift_group/modalEdit';
import ModalDelete from '../../components/account_working_shift_group/modalDelete';
import Expired from '../expired/index';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';

class AccountWorkingShiftGroup extends Component {
  constructor(props) {
    super(props);
    let initialConfig = {
        id: null,
        alias: '',
        isDynamicShift: false,
        quantityDays: '',
        planning: null,
        shiftStart: null,
        maxTimeToSendReportInMinutes: '',
        maxTimeToGradeAfterInMinutes: '',
        maxTimeToGradeBeforeInMinutes: '',
        mailRecipients: ''
      };

    this.state = {
      pag: 1,
      sort: true,
      modalEdit: false,
      modalDelete: false,
      modalActive: false,
      initialConfig: initialConfig,
      config: initialConfig
    };
  }

  /*
   * In the DidMount state, the content is loaded, where the requested functions are:
   * fetchAccountWorkingShiftGroupApi (get list of drivers)
   * fetchAccountWorkingShiftGroupCountApi (get total drivers and their pages)
   */
  async componentDidMount() {
    // call to the local store function with which we obtain the permissions
    const permits = localStoreFN().getItem('permits');
    const permitFfdSleep = permits.includes('ffdsleep');
    const permitFfdPvt = permits.includes('ffdpvt');
    // condition where we validate if we have the necessary settings and permissions
    if (permitFfdSleep || permitFfdPvt) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')
          && (obj.generalSetting.views.includes('ffdsleep')
            || obj.generalSetting.views.includes('ffdpvt'))) {
          await this.props.actions.fetchAccountWorkingShiftGroupApi({
            pag: this.state.pag
          });
          await this.props.actions.fetchAccountWorkingShiftGroupCountApi({});
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  //Manage redux state changes
  async componentDidUpdate(prevProps) {  

  }

  /*
   * En estado WillUnmount se realiza un reset de los reducer
   * la funcion solicitada
   * resetAccountWorkingShiftGroup(resetea el reducers)
   */
  componentWillUnmount() {
    this.props.actions.resetAccountWorkingShiftGroup();
  }

  handleSearch = async event => {
    if (!this.props.loading) {
      const value = event.target.value;
      this.setState({ pag: 1 });
      await this.props.actions.fetchAccountWorkingShiftGroupNoLoadingApi({
        sort: this.state.sort,
        filter: value,
        pag: 1,
        concat: false
      });
      await this.props.actions.fetchAccountWorkingShiftGroupCountApi({
        filter: value
      });
    }
  };

  handleScroll = async event => {
    if (
      this.state.pag < this.props.count.pages &&
      this.state.modalEdit == false
    ) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight;
      const value = document.getElementById('search').value;
      if (scroll >= max) {
        this.setState({ pag: this.state.pag + 1 });
        const pag = this.state.pag + 1;
        await this.props.actions.fetchAccountWorkingShiftGroupNoLoadingApi({
          pag: pag,
          filter: value,
          concat: true,
          sort: this.state.sort
        });
      }
    }
  };

  handleSort = async event => {
    this.setState({ pag: 1 });
    const sort = this.state.sort ? false : true;
    const value = document.getElementById('search').value;
    await this.props.actions.fetchAccountWorkingShiftGroupNoLoadingApi({
      sort: sort,
      filter: value,
      pag: 1,
      concat: false
    });
    this.setState({ sort: this.state.sort ? false : true });
  };

  handleUpdate = async event => {
    if(this.state.config.id) {
      await this.props.actions.handleUpdateWorkingShiftGroup({ group: this.state.config });
    }
    else {
      await this.props.actions.handleCreateWorkingShiftGroup({ group: this.state.config });
    }
  };

  handleDelete = async event => {
    const code = document.getElementById('iddelete').value;
    await this.props.actions.handleDeleteWorkingShiftGroup({ id: code });
  };

  handleModalEdit = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalEdit ? false : true;
      this.setState({ modalEdit: reset });
      if (!reset) {
        this.setState({
          config: this.state.initialConfig
        });
        this.props.actions.resetModalWorkingShiftGroup();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountWorkingShiftGroupApi({
            pag: 1
          });
          await this.props.actions.fetchAccountWorkingShiftGroupCountApi({});
        }
      } else {
        if(e.target.dataset.record!="new") {
          const obj = JSON.parse(e.target.dataset.datos);

          this.setState({
            config: {
              id: obj.id,
              alias: obj.alias,
              isDynamicShift: obj.isDynamicShift,
              quantityDays: obj.quantityDays,
              planning: obj.planning,
              shiftStart: obj.shiftStart,
              maxTimeToSendReportInMinutes: obj.maxTimeToSendReportInMinutes,
              maxTimeToGradeAfterInMinutes: obj.maxTimeToGradeAfterInMinutes,
              maxTimeToGradeBeforeInMinutes: obj.maxTimeToGradeBeforeInMinutes,
              mailRecipients: obj.mailRecipients
            }
          });
        }
        else {
         this.setState({
            config: this.state.initialConfig
          });         
        }
      }
    }
  };

  handleModalDelete = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDelete ? false : true;
      this.setState({ modalDelete: reset });
      if (!reset) {
        this.props.actions.resetModalWorkingShiftGroup();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1});
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountWorkingShiftGroupApi({ pag: 1 });
          await this.props.actions.fetchAccountWorkingShiftGroupCountApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            id: obj.id,
            alias: obj.alias,
            isDynamicShift: obj.isDynamicShift,
            quantityDays: obj.quantityDays,
            planning: obj.planning,
            shiftStart: obj.shiftStart,
            maxTimeToSendReportInMinutes: obj.maxTimeToSendReportInMinutes,
            maxTimeToGradeAfterInMinutes: obj.maxTimeToGradeAfterInMinutes,
            maxTimeToGradeBeforeInMinutes: obj.maxTimeToGradeBeforeInMinutes,
            mailRecipients: obj.mailRecipients
          }
        });
      }
    }
  };

  handleChange = e => {
    let config = { ...this.state.config };
    var value = e.target.value;
    var toUpdate = e.target.dataset.update;
    var splitToUpdate = toUpdate ? toUpdate.split("_") : [];

    if(splitToUpdate.length>1) {
      var planingToUpdate = splitToUpdate[0];
      var planningIndex = splitToUpdate[1];
      var planningObject = config.planning[planningIndex];
      
      if(planningObject) {        
        if(e.target.type=="radio") {
          value = e.target.checked;
        }

        if(planingToUpdate=="hasShiftTrue" && value==true) {
          planningObject.hasShift = true;
          planningObject.startTime = null;
          planningObject.endTime = null;
        }
        else if(planingToUpdate=="hasShiftFalse" && value==true) {
          planningObject.hasShift = false;
          planningObject.startTime = null;
          planningObject.endTime = null;
        }
        else {
          planningObject[planingToUpdate] = value;
        }
      }
    }
    else {
      if(e.target.type=="checkbox") {
        value = e.target.checked;
      }

      if(toUpdate=="isDynamicShift" && value==true) {
        config.quantityDays = '';
        config.planning = null;
        config.shiftStart = null;
        config.maxTimeToSendReportInMinutes = '';
        config.maxTimeToGradeAfterInMinutes = '';
        config.maxTimeToGradeBeforeInMinutes = '';
        config.mailRecipients = '';
      }

      if(toUpdate=="quantityDays") {
        if(value=="" || +value==0) {
          config.planning=null;
        }
        else {
          config.planning = config.planning==null ? [] : config.planning;
          while(+value<config.planning.length) {
            config.planning.pop();
          }
          while(+value>config.planning.length) {
            config.planning.push({
              dayNumber: config.planning.length+1,
              hasShift: true,
              startTime: null,
              endTime: null
            });
          }
        }
      }

      config[toUpdate] = value;
    }

    this.setState({
      config
    });
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      let container = '';

      const permits = localStoreFN().getItem('permits');
      const buttonShow = permits.includes('workingshiftgroupcrud');

      const header = (
        <Header language={this.props.language.filter} handleSearch={this.handleSearch}/>
      );
      if (this.props.loading) {
        container = <Loading language={this.props.language} />;
      } else if (
        this.props.status === 401 ||
        this.props.statusSave === 401
      ) {
        container = <Expired history={this.props.history} language={this.props.language} />;
      } else if (
        this.props.status === 200
      ) {
        container = (
          <div className="main-container scroll">
            <Title language={this.props.language} />
            <Buttons
              buttonShow={buttonShow}
              handleModal={this.handleModalEdit}
              language={this.props.language ? this.props.language : ''}
            />
            <Table
              buttonShow={buttonShow}
              handleSort={this.handleSort}
              pag={this.state.pag}
              count={this.props.count}
              loadingTable={this.props.loadingTable}
              datos={this.props.datos}
              handleModal={this.handleModalEdit}
              handleModalDelete={this.handleModalDelete}
              language={this.props.language ? this.props.language : ''}
            />
            <ModalEdit
              handleChange={this.handleChange}
              handleSubmit={this.handleUpdate}
              handleModal={this.handleModalEdit}
              modal={this.state.modalEdit}
              statusSave={this.props.statusSave}
              loadingSave={this.props.loadingSave}
              dataSave={this.props.dataSave}
              config={this.state.config}
              language={this.props.language ? this.props.language : ''}
              activeViews={obj.generalSetting.views}
              permits={permits}
            />
            <ModalDelete
              handleSubmit={this.handleDelete}
              handleModal={this.handleModalDelete}
              modal={this.state.modalDelete}
              statusSave={this.props.statusSave}
              loadingSave={this.props.loadingSave}
              dataSave={this.props.dataSave}
              config={this.state.config}
              language={this.props.language ? this.props.language : ''}
            />
          </div>
        );
      } else if (
        this.props.status === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  language: state.reducer.dashboard.language,
  setting: state.reducer.dashboard.setting,

  datos: state.reducer.accountWorkingShiftGroup.datos,
  count: state.reducer.accountWorkingShiftGroup.count,
  loading: state.reducer.accountWorkingShiftGroup.loading,
  loadingTable: state.reducer.accountWorkingShiftGroup.loadingTable,
  status: state.reducer.accountWorkingShiftGroup.status,

  loadingSave: state.reducer.accountWorkingShiftGroup.loadingSave,
  statusSave: state.reducer.accountWorkingShiftGroup.statusSave,
  dataSave: state.reducer.accountWorkingShiftGroup.dataSave
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountWorkingShiftGroupActions, dispatch)
});

AccountWorkingShiftGroup.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountWorkingShiftGroup);



// WEBPACK FOOTER //
// ./source/client/containers/account_working_shift_group/index.jsx